export const mapData = {
  US: 7714912,
  IN: 6754179,
  BR: 4969141,
  RU: 1237504,
  CO: 869808,
  ES: 865631,
  PE: 829999,
  AR: 809728,
  MX: 789780,
  ZA: 683242,
  FR: 634763,
  GB: 530113,
  IR: 479825,
  CL: 473306,
  IQ: 387121,
  BD: 371631,
  SA: 337243,
  IT: 330263,
  TR: 327557,
  PH: 326833,
  PK: 315727,
  ID: 311176,
  DE: 307119,
  IL: 277026,
  UA: 234584,
  CA: 171221,
  NL: 144999,
  EC: 142056,
  RO: 139612,
  MA: 137248,
  BO: 137107,
  BE: 132203,
  QA: 126943,
  PA: 115919,
  DO: 115371,
  KZ: 108296,
  KW: 108268,
  PL: 104316,
  EG: 103902,
  OM: 102648,
  AE: 100794,
  SE: 96145,
  GT: 94870,
  NP: 90814,
  CZ: 87176,
  JP: 86047,
  CN: 85482,
  CR: 82142,
  BY: 81090,
  PT: 80312,
  HN: 80020,
  ET: 80003,
  VE: 79117,
  BH: 73476,
  NG: 59465,
  UZ: 59343,
  SG: 57830,
  MD: 57732,
  CH: 56632,
  AM: 53083,
  DZ: 52399,
  AT: 49819,
  KG: 47799,
  LB: 46918,
  GH: 46829,
  PY: 44715,
  PS: 42432,
  AZ: 40931,
  KE: 39586,
  AF: 39486,
  IE: 38973,
  LY: 38468,
  RS: 34072,
  HU: 32298,
  DK: 30379,
  SV: 29634,
  BA: 28710,
  AU: 27173,
  KR: 24239,
  BG: 22306,
  TN: 22230,
  CM: 20924,
  GR: 20541,
  MM: 20033,
  CI: 19903,
  MK: 19096,
  JO: 19001,
  HR: 18084,
  MG: 16600,
  ZM: 15170,
  SN: 15141,
  NO: 14669,
  AL: 14568,
  SK: 13812,
  SD: 13653,
  MY: 13504,
  ME: 12584,
  NA: 11673,
  FI: 10929,
  GN: 10863,
  CD: 10789,
  MV: 10621,
  GF: 10070,
  TJ: 10014,
  MZ: 9398,
  GE: 9245,
  UG: 9082,
  LU: 8979,
  HT: 8838,
  GA: 8808,
  ZW: 7915,
  MR: 7523,
  JM: 7109,
  SI: 6764,
  CV: 6518,
  CU: 5883,
  MW: 5796,
  AO: 5725,
  SZ: 5598,
  GP: 5528,
  DJ: 5423,
  LT: 5366,
  NI: 5170,
  HK: 5133,
  CG: 5089,
  GQ: 5052,
  SR: 4954,
  RW: 4873,
  CF: 4852,
  TT: 4846,
  BS: 4559,
  SY: 4457,
  RE: 4328,
  LK: 4252,
  AW: 4108,
  YT: 3892,
  SO: 3745,
  EE: 3659,
  GM: 3613,
  TH: 3600,
  MT: 3374,
  ML: 3195,
  GY: 3188,
  BW: 3172,
  IS: 3081,
  SS: 2734,
  GW: 2385,
  AD: 2370,
  BJ: 2357,
  SL: 2277,
  PF: 2228,
  BZ: 2204,
  BF: 2197,
  LV: 2194,
  UY: 2155,
  YE: 2047,
  TG: 1881,
  CY: 1876,
  NZ: 1858,
  LS: 1683,
  MQ: 1543,
  LR: 1354,
  TD: 1238,
  NE: 1200,
  VN: 1098,
  ST: 913,
  SM: 732,

  TC: 695,
  SX: 686,
  PG: 541,
  TW: 521,
  BI: 514,
  TZ: 509,
  KM: 491,
  CW: 476,
  FO: 475,
  GI: 437,
  MF: 412,
  ER: 398,
  MU: 387,
  IM: 345,
  MN: 315,
  BT: 299,
  KH: 280,
  MC: 224,
  KY: 213,
  BB: 200,
  BM: 181,
  SC: 148,
  BN: 146,
  BQ: 141,
  LI: 130,
  AG: 107,
  VG: 71,
  VC: 64,
  BL: 62,
  MO: 46,
  FJ: 32,
  DM: 31,
  TL: 28,
  NC: 27,
  LC: 27,
  GD: 24,
  LA: 23,
  KN: 19,
  PM: 16,
  GL: 14,
  MS: 13,
  FK: 13,
  VA: 12,
  EH: 10,
  AI: 3
};

// export const mapData = {
//   AF: 2370,
//   AL: 11.58,
//   DZ: 158.97,
//   AO: 85.81,
//   AG: 1.1,
//   AR: 351.02,
//   AM: 8.83,
//   AU: 1219.72,
//   AT: 366.26,
//   AZ: 52.17,
//   BS: 7.54,
//   BH: 21.73,
//   BD: 105.4,
//   BB: 3.96,
//   BY: 52.89,
//   BE: 461.33,
//   BZ: 1.43,
//   BJ: 6.49,
//   BT: 1.4,
//   BO: 19.18,
//   BA: 16.2,
//   BW: 12.5,
//   BR: 2023.53,
//   BN: 11.96,
//   BG: 44.84,
//   BF: 8.67,
//   BI: 1.47,
//   KH: 11.36,
//   CM: 21.88,
//   CA: 1563.66,
//   CV: 1.57,
//   CF: 2.11,
//   TD: 7.59,
//   CL: 199.18,
//   CN: 5745.13,
//   CO: 283.11,
//   KM: 0.56,
//   CD: 12.6,
//   CG: 11.88,
//   CR: 35.02,
//   CI: 22.38,
//   HR: 59.92,
//   CY: 22.75,
//   CZ: 195.23,
//   DK: 304.56,
//   DJ: 1.14,
//   DM: 0.38,
//   DO: 50.87,
//   EC: 61.49,
//   EG: 216.83,
//   SV: 21.8,
//   GQ: 14.55,
//   ER: 2.25,
//   EE: 19.22,
//   ET: 30.94,
//   FJ: 3.15,
//   FI: 231.98,
//   FR: 2555.44,
//   GA: 12.56,
//   GM: 1.04,
//   GE: 11.23,
//   DE: 3305.9,
//   GH: 18.06,
//   GR: 305.01,
//   GD: 0.65,
//   GT: 40.77,
//   GN: 4.34,
//   GW: 0.83,
//   GY: 2.2,
//   HT: 6.5,
//   HN: 15.34,
//   HK: 226.49,
//   HU: 132.28,
//   IS: 12.77,
//   IN: 1430.02,
//   ID: 695.06,
//   IR: 337.9,
//   IQ: 84.14,
//   IE: 204.14,
//   IL: 201.25,
//   IT: 2036.69,
//   JM: 13.74,
//   JP: 5390.9,
//   JO: 27.13,
//   KZ: 129.76,
//   KE: 32.42,
//   KI: 0.15,
//   KR: 986.26,
//   UNDEFINED: 5.73,
//   KW: 117.32,
//   KG: 4.44,
//   LA: 6.34,
//   LV: 23.39,
//   LB: 39.15,
//   LS: 1.8,
//   LR: 0.98,
//   LY: 77.91,
//   LT: 35.73,
//   LU: 52.43,
//   MK: 9.58,
//   MG: 8.33,
//   MW: 5.04,
//   MY: 218.95,
//   MV: 1.43,
//   ML: 9.08,
//   MT: 7.8,
//   MR: 3.49,
//   MU: 9.43,
//   MX: 1004.04,
//   MD: 5.36,
//   MN: 5.81,
//   ME: 3.88,
//   MA: 91.7,
//   MZ: 10.21,
//   MM: 35.65,
//   NA: 11.45,
//   NP: 15.11,
//   NL: 770.31,
//   NZ: 138,
//   NI: 6.38,
//   NE: 5.6,
//   NG: 206.66,
//   NO: 413.51,
//   OM: 53.78,
//   PK: 174.79,
//   PA: 27.2,
//   PG: 8.81,
//   PY: 17.17,
//   PE: 153.55,
//   PH: 189.06,
//   PL: 438.88,
//   PT: 223.7,
//   QA: 126.52,
//   RO: 158.39,
//   RU: 1476.91,
//   RW: 5.69,
//   WS: 0.55,
//   ST: 0.19,
//   SA: 434.44,
//   SN: 12.66,
//   RS: 38.92,
//   SC: 0.92,
//   SL: 1.9,
//   SG: 217.38,
//   SK: 86.26,
//   SI: 46.44,
//   SB: 0.67,
//   ZA: 354.41,
//   ES: 1374.78,
//   LK: 48.24,
//   KN: 0.56,
//   LC: 1,
//   VC: 0.58,
//   SD: 65.93,
//   SR: 3.3,
//   SZ: 3.17,
//   SE: 444.59,
//   CH: 522.44,
//   SY: 59.63,
//   TW: 426.98,
//   TJ: 5.58,
//   TZ: 22.43,
//   TH: 312.61,
//   TL: 0.62,
//   TG: 3.07,
//   TO: 0.3,
//   TT: 21.2,
//   TN: 43.86,
//   TR: 729.05,
//   TM: 0,
//   UG: 17.12,
//   UA: 136.56,
//   AE: 239.65,
//   GB: 2258.57,
//   US: 14624.18,
//   UY: 40.71,
//   UZ: 37.72,
//   VU: 0.72,
//   VE: 285.21,
//   VN: 101.99,
//   YE: 30.02,
//   ZM: 15.69,
//   ZW: 5.57
// }

// export const mapData = {
//   AF: 16.63,
//   AL: 11.58,
//   DZ: 158.97,
//   AO: 85.81,
//   AG: 1.1,
//   AR: 351.02,
//   AM: 8.83,
//   AU: 1219.72,
//   AT: 366.26,
//   AZ: 52.17,
//   BS: 7.54,
//   BH: 21.73,
//   BD: 105.4,
//   BB: 3.96,
//   BY: 52.89,
//   BE: 461.33,
//   BZ: 1.43,
//   BJ: 6.49,
//   BT: 1.4,
//   BO: 19.18,
//   BA: 16.2,
//   BW: 12.5,
//   BR: 2023.53,
//   BN: 11.96,
//   BG: 44.84,
//   BF: 8.67,
//   BI: 1.47,
//   KH: 11.36,
//   CM: 21.88,
//   CA: 1563.66,
//   CV: 1.57,
//   CF: 2.11,
//   TD: 7.59,
//   CL: 199.18,
//   CN: 5745.13,
//   CO: 283.11,
//   KM: 0.56,
//   CD: 12.6,
//   CG: 11.88,
//   CR: 35.02,
//   CI: 22.38,
//   HR: 59.92,
//   CY: 22.75,
//   CZ: 195.23,
//   DK: 304.56,
//   DJ: 1.14,
//   DM: 0.38,
//   DO: 50.87,
//   EC: 61.49,
//   EG: 216.83,
//   SV: 21.8,
//   GQ: 14.55,
//   ER: 2.25,
//   EE: 19.22,
//   ET: 30.94,
//   FJ: 3.15,
//   FI: 231.98,
//   FR: 2555.44,
//   GA: 12.56,
//   GM: 1.04,
//   GE: 11.23,
//   DE: 3305.9,
//   GH: 18.06,
//   GR: 305.01,
//   GD: 0.65,
//   GT: 40.77,
//   GN: 4.34,
//   GW: 0.83,
//   GY: 2.2,
//   HT: 6.5,
//   HN: 15.34,
//   HK: 226.49,
//   HU: 132.28,
//   IS: 12.77,
//   IN: 1430.02,
//   ID: 695.06,
//   IR: 337.9,
//   IQ: 84.14,
//   IE: 204.14,
//   IL: 201.25,
//   IT: 2036.69,
//   JM: 13.74,
//   JP: 5390.9,
//   JO: 27.13,
//   KZ: 129.76,
//   KE: 32.42,
//   KI: 0.15,
//   KR: 986.26,
//   UNDEFINED: 5.73,
//   KW: 117.32,
//   KG: 4.44,
//   LA: 6.34,
//   LV: 23.39,
//   LB: 39.15,
//   LS: 1.8,
//   LR: 0.98,
//   LY: 77.91,
//   LT: 35.73,
//   LU: 52.43,
//   MK: 9.58,
//   MG: 8.33,
//   MW: 5.04,
//   MY: 218.95,
//   MV: 1.43,
//   ML: 9.08,
//   MT: 7.8,
//   MR: 3.49,
//   MU: 9.43,
//   MX: 1004.04,
//   MD: 5.36,
//   MN: 5.81,
//   ME: 3.88,
//   MA: 91.7,
//   MZ: 10.21,
//   MM: 35.65,
//   NA: 11.45,
//   NP: 15.11,
//   NL: 770.31,
//   NZ: 138,
//   NI: 6.38,
//   NE: 5.6,
//   NG: 206.66,
//   NO: 413.51,
//   OM: 53.78,
//   PK: 174.79,
//   PA: 27.2,
//   PG: 8.81,
//   PY: 17.17,
//   PE: 153.55,
//   PH: 189.06,
//   PL: 438.88,
//   PT: 223.7,
//   QA: 126.52,
//   RO: 158.39,
//   RU: 1476.91,
//   RW: 5.69,
//   WS: 0.55,
//   ST: 0.19,
//   SA: 434.44,
//   SN: 12.66,
//   RS: 38.92,
//   SC: 0.92,
//   SL: 1.9,
//   SG: 217.38,
//   SK: 86.26,
//   SI: 46.44,
//   SB: 0.67,
//   ZA: 354.41,
//   ES: 1374.78,
//   LK: 48.24,
//   KN: 0.56,
//   LC: 1,
//   VC: 0.58,
//   SD: 65.93,
//   SR: 3.3,
//   SZ: 3.17,
//   SE: 444.59,
//   CH: 522.44,
//   SY: 59.63,
//   TW: 426.98,
//   TJ: 5.58,
//   TZ: 22.43,
//   TH: 312.61,
//   TL: 0.62,
//   TG: 3.07,
//   TO: 0.3,
//   TT: 21.2,
//   TN: 43.86,
//   TR: 729.05,
//   TM: 0,
//   UG: 17.12,
//   UA: 136.56,
//   AE: 239.65,
//   GB: 2258.57,
//   US: 14624.18,
//   UY: 40.71,
//   UZ: 37.72,
//   VU: 0.72,
//   VE: 285.21,
//   VN: 101.99,
//   YE: 30.02,
//   ZM: 15.69,
//   ZW: 5.57
// }
